import React from 'react';
import Autocomplete from "react-google-autocomplete";
const SearchOptionsGetPlace = {
    strictBounds: false,
    componentRestrictions: { country: "us" },
    types: ["address"]
}
const ApikeyforGooglePlace = "AIzaSyAZH0fIwN7jXD4-AovdEGNj5Tp2WHxR47g";

/*global google*/
const GetPlace = props => {
    return <Autocomplete
       apiKey={ApikeyforGooglePlace}
        options={SearchOptionsGetPlace}
        className={props.className}
        id={props.id}
        placeholder={props.placeholder}
        name={props.name}
        defaultValue={props.defaultValue}
        inputAutocompleteValue={props.inputAutocompleteValue}
        onPlaceSelected={props.onPlaceSelected}
        onChange={props.onChange}
        required
/>
}
export default GetPlace